import 'mdn-polyfills/Object.assign'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React, { ReactElement } from 'react'

import './localization/localization.helper'

import localizeInit from 'localization/localization'
import { createRoot } from 'react-dom/client'
import { createBrowserRouter } from 'react-router'
import { RouterProvider } from 'react-router/dom'
import { LoadingPlaceholderContainer } from 'ui/atoms'
import AllProviders from 'ui/components/AllProviders/AllProviders'
import schedulerInit from 'utils/scheduler/scheduler'
import sentry from 'utils/sentry/sentry'

import App from './ui/components/App/App'
import './index.module.less'
import './dev'
import './index.css'
import 'react-quill-new/dist/quill.snow.css'

localizeInit()
sentry.init()
schedulerInit()

const router = createBrowserRouter([
  {
    path: '*',
    element: (
      <React.Suspense fallback={<LoadingPlaceholderContainer height="100%" />}>
        <App />
      </React.Suspense>
    ),
  },
])

const Root = (): ReactElement => {
  return (
    <AllProviders>
      <RouterProvider router={router} />
    </AllProviders>
  )
}

const container = document.getElementById(`root`)
if (!container) {
  throw new Error(`Container not found`)
}
const root = createRoot(container)

root.render(<Root />)

export default Root
